(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["64only-atelier"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('.atelier64').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const brandToggle = root.querySelector('.brands-toggle64');
    brandToggle?.addEventListener('click', () => {
      const expanded = brandToggle.getAttribute('aria-expanded') !== 'true';
      brandToggle.setAttribute('aria-expanded', String(expanded));
      root.querySelector('.atelier64__brands').classList.toggle('brands-expanded64', expanded);
      brandToggle.innerHTML = expanded ? 'Show fewer brands <span aria-hidden="true">−</span>' : 'View all brands <span aria-hidden="true">+</span>';
    });
    const button = root.querySelector('.atelier64__motion');
    const slides = [...root.querySelectorAll('.atelier64__slide')];
    const tabs = [...root.querySelectorAll('.atelier64__slidesnav button')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let timer;
    const show = index => {
      current = index;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === index)));
    };
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (!reduced.matches && !root.hasAttribute('data-paused') && !document.hidden) timer = setInterval(() => show((current + 1) % slides.length), 7500);
    };
    button?.addEventListener('click', () => {
      const paused = root.toggleAttribute('data-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Play background animation' : 'Pause background animation');
      button.textContent = paused ? '▶' : 'Ⅱ';
      start();
    });
    tabs.forEach((tab, i) => tab.addEventListener('click', () => { show(i); start(); }));
    reduced.addEventListener('change', start);
    document.addEventListener('visibilitychange', start);
    const observer = new IntersectionObserver(entries => entries[0].isIntersecting ? start() : stop());
    observer.observe(root.querySelector('.atelier64__hero'));
    start();
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["64only-garage-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('.garage-hero').forEach(hero => {
    if (hero.dataset.motionReady) return;
    hero.dataset.motionReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const button = hero.querySelector('.garage-hero__motion');
    button?.addEventListener('click', () => {
      const paused = hero.toggleAttribute('data-motion-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Play animation' : 'Pause animation');
      button.textContent = paused ? '▶' : 'Ⅱ';
    });
    let frame;
    hero.addEventListener('pointermove', event => {
      if (reduced.matches || event.pointerType !== 'mouse' || hero.hasAttribute('data-motion-paused')) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const rect = hero.getBoundingClientRect();
        hero.style.setProperty('--garage-x', ((event.clientX - rect.left) / rect.width - .5) * 18 + 'px');
        hero.style.setProperty('--garage-y', ((event.clientY - rect.top) / rect.height - .5) * 10 + 'px');
      });
    });
    hero.addEventListener('pointerleave', () => {
      cancelAnimationFrame(frame);
      hero.style.setProperty('--garage-x', '0px');
      hero.style.setProperty('--garage-y', '0px');
    });
    const observer = new IntersectionObserver(entries => {
      hero.querySelector('.garage-hero__media').style.animationPlayState = entries[0].isIntersecting && !hero.hasAttribute('data-motion-paused') ? '' : 'paused';
    });
    observer.observe(hero);
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
